"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLocationTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const address_transport_1 = require("./address-transport");
exports.ServiceLocationTransport = typebox_1.Type.Object({
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    address: address_transport_1.AddressTransport,
    coordinates: typebox_1.Type.Object({
        lat: typebox_1.Type.Number(),
        lng: typebox_1.Type.Number(),
    }),
    county: typebox_1.Type.String(),
});
//# sourceMappingURL=service-location.js.map